const findInFileArray = (files, fileId) => {
  for (const file of files) {
    if (file.fileId === fileId) {
      return file;
    } else if (file.children) {
      const children = findInFileArray(file.children, fileId);
      if (children) return children;
    }
  }
  return null;
};

export default findInFileArray;



// WEBPACK FOOTER //
// ./src/utility/findInFileArray.js